// extracted by mini-css-extract-plugin
module.exports = {"chunkLoading":"ProductGrid_chunkLoading__KTAcX","chunkLoadErrorMessage":"ProductGrid_chunkLoadErrorMessage__BTQ0C"};